import { privacyOnEnterSaga } from 'containers/Privacy/privacy.onenter.saga';
import { redirectTo } from 'helpers/path'; // polyfill webpack require.ensure

if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
var rootPath = '/privacy';
export var PrivacyRoute = function PrivacyRoute(store) {
  return {
    path: rootPath,
    onEnter: function onEnter(nextState, replaceState, cb) {
      return store.runSagaOnce(privacyOnEnterSaga, store, nextState, replaceState).done.then(cb);
    },
    getComponent: function getComponent(location, callback) {
      require.ensure([], function (require) {
        callback(null, require('components/Privacy/Privacy').Privacy);
      }, 'privacy');
    },
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, {
          component: require('features/Privacy/PrivacyContainer').PrivacyContainer
        });
      }, 'privacy');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          path: 'australia',
          onEnter: redirectTo("".concat(rootPath, "/aus"))
        }, {
          path: 'canada',
          onEnter: redirectTo("".concat(rootPath, "/can"))
        }, {
          path: 'uk',
          onEnter: redirectTo("".concat(rootPath, "/gbr"))
        }, {
          path: ':countryCode',
          component: require('features/Privacy/PrivacyContainer').PrivacyContainer
        }]);
      }, 'privacy');
    }
  };
};